// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../types';

import gql from 'graphql-tag';
export type GetAddressProposalFragment = { __typename?: 'Proposal', space: { __typename?: 'SelfServeSpace', venue?: { __typename?: 'SelfServeVenue', addressLine1?: string | null, city?: string | null, postalCode?: string | null } | null } };

export const GetAddressProposalFragmentDoc = gql`
    fragment GetAddressProposal on Proposal {
  space {
    venue {
      addressLine1
      city
      postalCode
    }
  }
}
    `;